// extracted by mini-css-extract-plugin
export default {"price":"price--price","price_formatted":"price--price_formatted","priceComparison_formatted":"price--priceComparison_formatted","priceAsText":"price--priceAsText"};